import React, { useMemo, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ChangeTripList from '../changeRes/ChangeTripList';
import WrapBottomColor from '../containers/WrapBottomColor';
import BottomButton from '../BottomButton';
import { changeResPayload } from '../../store/actions/search';
import { updateAirLegs } from '../../store/actions/payment';
import moment from 'moment';
import { useNavigation } from '@react-navigation/native';
import { Modals } from '../../constants/ScreenNames';
import { View, StyleSheet } from 'react-native';
import { CommonProperties } from '../../styles';
import { selectFirstReceipt } from '../../store/selectors/mytrips.selector';

const ChangeResModal = () => {
  const navigation = useNavigation();
  const finalCriteria = [];
  const [checkedFlights, setcheckedFlights] = useState({});
  const [selectedLegs, setSelectedLegs] = useState(false);
  const receiptResponse = useSelector(selectFirstReceipt);
  const airlistResponse = useMemo(() => {
    return receiptResponse?.AirResponseDetails ? [receiptResponse?.AirResponseDetails] : null;
  }, [receiptResponse]);
  const dispatch = useDispatch();

  function handleChange(newValue) {
    setcheckedFlights(newValue);
  }

  const onChangeSubmit = () => {
    const data = [];
    for (let i = 0; i < airlistResponse[0]?.AirLegs.length; i++) {
      if (checkedFlights[i] == true) {
        data.push(airlistResponse[0]?.AirLegs[i]);
      }
    }
    if (data.length > 0) {
      setSelectedLegs(true);
      dispatch(updateAirLegs(data));
      data?.map((leg) => {
        const searchCriteria = {
          departureAirport: '',
          departRegionId: 0,
          departParentKey: 0,
          fromCity: '',
          fromDate: '',
          arrivalAirport: '',
          arrivalRegionId: 0,
          arrivalParentKey: 0,
          toCity: '',
          toDate: '',
        };
        leg.AirSegments.map((airSegment, index) => {
          if (index == 0) {
            searchCriteria.departureAirport = airSegment.DepartAirportCityName;
            searchCriteria.fromCity = airSegment.DepartureAirportCode;
            const departureDate = moment(airSegment.DepartureDate).format('YYYY-MM-DD');
            searchCriteria.fromDate = departureDate;
          }
          if (index === leg.AirSegments.length - 1) {
            searchCriteria.arrivalAirport = airSegment.ArrivalAirportCityName;
            searchCriteria.toCity = airSegment.ArrivalAirportCode;
            const arrivalDate = moment(airSegment.ArrivalDate).format('YYYY-MM-DD');
            searchCriteria.toDate = arrivalDate;
          }
        });
        finalCriteria.push(searchCriteria);
      });
    }

    const newState = {
      hasAir: true,
      hasHotel: false,
      hasCar: false,
      hasRail: false,
      dominantSearchType: 'air',
      subSearchType:
        finalCriteria.length === 1 ? 'oneway' : finalCriteria.length > 1 ? 'multicity' : null,
      searchCriteria: finalCriteria,
      enableSearchTypeSelector: false,
      enablePassengerClass: false,
    };
    navigation.navigate(Modals.ChangeResWidget, {
      data: data,
      newState: newState,
      finalCriteria: finalCriteria,
    });
  };

  useEffect(() => {
    if (selectedLegs) {
      dispatch(changeResPayload(receiptResponse));
    }
  }, [dispatch, receiptResponse, selectedLegs]);

  return (
    <WrapBottomColor>
      <View style={styles.container}>
        <ChangeTripList
          onChange={handleChange}
          response={receiptResponse}
          airResponse={airlistResponse}
        />
      </View>
      <BottomButton label="Change" full onPress={onChangeSubmit} />
    </WrapBottomColor>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    ...CommonProperties.p3,
  },
});
export default ChangeResModal;
